import getMeta from './get_meta';

/**
 * Gets the landing page attached to a form
 */
export default function getLandingPage(_form) {
  return getMeta('landing_page');
}

